<mat-drawer-container
  class="h-full"
  [class.select-none]="isResizing()"
  autosize="false"
  (mouseup)="handleMouseUp()"
  (mousemove)="handleMouseMove($event)"
>
  <mat-drawer
    disableClose
    mode="side"
    [opened]="!sidebarCollapsed()"
    [style.--mat-sidenav-container-width.px]="drawerSize()"
    class="border-0! !transition-none"
  >
    <div class="h-full flex flex-col">
      <div class="ml-4 overflow-auto scrollbar-width-thin flex-auto">
        <div class="mr-4">
          @if (pinnedFolders().length > 0) {
            <div>
              <div
                class="text-xs uppercase tracking-widest font-medium pb-2 px-4 before:w-0 before:h-8 before:align-0 before:inline-block"
              >
                Snelle toegang
              </div>

              <div class="pb-2">
                @for (folder of pinnedFolders(); track folder._id) {
                  <div
                    class="group h-8 px-2 flex items-center rounded-full hover:bg-gray-200 hover:cursor-pointer [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
                    [class.active]="!isSharedView() && folder._id === selectedFolderId()"
                  >
                    <div class="w-3 h-3 flex-none"></div>
                    <div
                      class="flex flex-auto items-center text-xl gap-1 min-w-0"
                      (click)="navigateFolder(folder._id, false)"
                      role="presentation"
                    >
                      <mat-icon inline class="flex-none">folder</mat-icon>
                      <span class="flex-auto truncate font-medium text-sm">
                        {{ folder.label }}
                      </span>
                    </div>

                    <button
                      mat-icon-button
                      class="flex items-center justify-center size-8! p-0.5! -mr-2 [font-variation-settings:'FILL'_1] hover:[font-variation-settings:'FILL'_0] transition-all!"
                      [matTooltip]="'Losmaken'"
                      (click)="togglePin(folder._id, $event)"
                    >
                      <mat-icon class="!text-base">push_pin</mat-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <div
            class="text-xs uppercase tracking-widest font-medium pb-2 px-4 before:w-0 before:h-8 before:align-0 before:inline-block"
          >
            Verkenner
          </div>

          <mat-tree
            class="pb-4"
            #tree
            [dataSource]="treeNodes()"
            [childrenAccessor]="childrenAccessor"
            [trackBy]="trackByNodeFn"
            [expansionKey]="expansionKeyFn"
          >
            <mat-nested-tree-node *matTreeNodeDef="let node; let level = level">
              <div
                class="group h-8 px-2 flex items-center rounded-full hover:bg-gray-200 hover:cursor-pointer [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
                [class.expanded]="tree.isExpanded(node)"
                [class.active]="!isSharedView() && node.id === selectedFolderId()"
              >
                @for (_ of [].constructor(level); track $index) {
                  <div class="w-4 h-3 flex-none"></div>
                }
                <div class="w-3 h-3 flex-none" matTreeNodeToggle>
                  <div class="h-3 flex items-center justify-center">
                    <mat-icon
                      class="!flex items-center justify-center cursor-default size-4 flex-none !text-base -rotate-90 group-[.expanded]:rotate-0 transition-transform"
                      >arrow_drop_down</mat-icon
                    >
                  </div>
                </div>
                <div
                  class="flex flex-auto items-center text-xl gap-1 min-w-0"
                  (click)="navigateFolder(node.id, false)"
                  role="presentation"
                >
                  <mat-icon inline class="flex-none">folder</mat-icon>

                  <span class="flex-auto truncate font-medium text-sm">{{
                    node.name
                  }}</span>
                </div>

                @if (node.id !== VIRTUAL_ROOT_NODE_ID) {
                  <button
                    mat-icon-button
                    class="flex items-center justify-center opacity-0 group-hover:opacity-100 size-8! p-0.5! -mr-2 transition-all!"
                    [ngClass]="{
                      '[font-variation-settings:\'FILL\'_1] hover:[font-variation-settings:\'FILL\'_0]': isPinned(node.id),
                      '[font-variation-settings:\'FILL\'_0] hover:[font-variation-settings:\'FILL\'_1]': !isPinned(node.id),
                    }"
                    [matTooltip]="isPinned(node.id) ? 'Losmaken' : 'Vastmaken'"
                    (click)="togglePin(node.id, $event)"
                  >
                    <mat-icon class="!text-base">push_pin</mat-icon>
                  </button>
                }
              </div>

              <div
                [class]="!tree.isExpanded(node) ? 'h-0' : 'h-auto'"
                class="overflow-hidden transition-[height]"
                role="group"
              >
                <ng-container *matTreeNodeOutlet></ng-container>
              </div>
            </mat-nested-tree-node>
          </mat-tree>

          @if (canViewSharedMedia()) {
          <div class="pb-4">
            <div
              class="text-xs uppercase tracking-widest font-medium pb-2 px-4 before:w-0 before:h-8 before:align-0 before:inline-block"
            >
              Gedeeld
            </div>
            <div
              class="group h-8 px-2 flex items-center rounded-full hover:bg-gray-200 hover:cursor-pointer [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
              [class.active]="isSharedView() && !currentGroupId()"
              [class.expanded]="isSharedExpanded()"
              role="presentation"
            >
              <div
                class="w-3 h-3 flex-none"
                (click)="isSharedExpanded.set(!isSharedExpanded()); $event.stopPropagation()"
                (keydown.enter)="isSharedExpanded.set(!isSharedExpanded()); $event.stopPropagation()"
                tabindex="0"
              >
                @if (sharedTreeNodes().length > 0) {
                  <div class="h-3 flex items-center justify-center">
                    <mat-icon
                      class="!flex items-center justify-center cursor-default size-4 flex-none !text-base -rotate-90 group-[.expanded]:rotate-0 transition-transform"
                      >arrow_drop_down</mat-icon
                    >
                  </div>
                }
              </div>
              <div
                class="flex flex-auto items-center text-xl gap-1 min-w-0"
                (click)="navigateToShared()"
                role="presentation"
              >
                <mat-icon inline class="flex-none">folder_shared</mat-icon>
                <span class="flex-auto truncate font-medium text-sm">Gedeelde media</span>
              </div>
            </div>

            @if (isSharedExpanded()) {
              <div class="overflow-hidden">
                <ng-container
                  *ngTemplateOutlet="sharedTreeTemplate; context: { $implicit: sharedTreeNodes(), level: 1 }"
                ></ng-container>
              </div>
            }
          </div>

          <ng-template #sharedTreeTemplate let-nodes let-level="level">
            @for (node of nodes; track node.id) {
              <div
                class="group h-8 px-2 flex items-center rounded-full hover:bg-gray-200 hover:cursor-pointer [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
                [class.active]="isSharedView() && node.id === currentGroupId()"
                [class.expanded]="isSharedNodeExpanded(node.id)"
              >
                @for (_ of [].constructor(level); track $index) {
                  <div class="w-4 h-3 flex-none"></div>
                }
                <div
                  class="w-3 h-3 flex-none"
                  (click)="node.children.length ? toggleSharedExpand(node.id, $event) : null"
                  (keydown.enter)="node.children.length ? toggleSharedExpand(node.id, $event) : null"
                  tabindex="0"
                >
                  @if (node.children.length > 0) {
                    <div class="h-3 flex items-center justify-center">
                      <mat-icon
                        class="!flex items-center justify-center cursor-default size-4 flex-none !text-base -rotate-90 group-[.expanded]:rotate-0 transition-transform"
                        >arrow_drop_down</mat-icon
                      >
                    </div>
                  }
                </div>
                <div
                  class="flex flex-auto items-center text-xl gap-1 min-w-0"
                  (click)="navigateToSharedFolder(node.id)"
                  role="presentation"
                >
                  <mat-icon inline class="flex-none">folder</mat-icon>
                  <span class="flex-auto truncate font-medium text-sm">{{ node.name }}</span>
                </div>
              </div>

              @if (isSharedNodeExpanded(node.id) && node.children.length > 0) {
                <ng-container
                  *ngTemplateOutlet="sharedTreeTemplate; context: { $implicit: node.children, level: level + 1 }"
                ></ng-container>
              }
            }
          </ng-template>
          }
        </div>
      </div>

      <div
        class="absolute inset-y-0 right-0 border-r border-gray-200 hover:border-gray-300 hover:border-2 hover:cursor-ew-resize [.resizing]:border-2 [.resizing]:cursor-ew-resize"
        [class.resizing]="isResizing()"
        (mousedown)="handleMouseDown()"
      ></div>
    </div>
  </mat-drawer>

  <mat-drawer-content
    class="!transition-none bg-gray-100"
    [style.margin-left.px]="sidebarCollapsed() ? 0 : drawerSize()"
  >
    <div class="h-full overflow-auto scrollbar-width-thin">
      <div class="container h-full flex flex-col gap-8 mx-auto px-4 md:px-6 pt-8 pb-4">
        <div class="flex justify-between">
          <div class="flex items-center">
            <button
              mat-icon-button
              class="inline-flex! -ml-2"
              [matTooltip]="sidebarCollapsed() ? 'Zijbalk tonen' : 'Zijbalk verbergen'"
              (click)="toggleSidebar()"
            >
              <mat-icon>{{ sidebarCollapsed() ? 'left_panel_open' : 'left_panel_close' }}</mat-icon>
            </button>
            <app-breadcrumbs [breadcrumbs]="breadcrumbs()" class="-ml-1">
            <ng-container *appBreadcrumbDef="let breadcrumb; let last = last">
              @if (last) {
                <button
                  mat-button
                  [matTooltip]="breadcrumb.name"
                  class="!text-2xl [--mat-text-button-with-icon-horizontal-padding:12px] [--mdc-text-button-label-text-color:var(--color-black)] [--mat-text-button-state-layer-color:var(--color-black)] [--mat-text-button-ripple-color:var(--breadcrumb-ripple-color)]"
                >
                  <span class="w-min max-w-80 truncate block">{{
                    breadcrumb.name
                  }}</span>
                </button>
              } @else {
                <button
                  mat-button
                  [matTooltip]="breadcrumb.name"
                  class="!text-2xl [--mdc-text-button-label-text-color:var(--color-black)] [--mat-text-button-state-layer-color:var(--color-black)] [--mat-text-button-ripple-color:var(--breadcrumb-ripple-color)]"
                  (click)="navigateFolder(breadcrumb.id)"
                >
                  <span class="w-min max-w-80 truncate block">{{
                    breadcrumb.name
                  }}</span>
                </button>
              }
            </ng-container>

            <ng-template #menu let-breadcrumbs>
              <button
                mat-icon-button
                [matMenuTriggerFor]="moreItemsMenu"
                class="flex!"
                matTooltip="Meer"
              >
                <mat-icon>more_horiz</mat-icon>
              </button>

              <mat-menu #moreItemsMenu="matMenu">
                @for (breadcrumb of breadcrumbs; track $index) {
                  <button mat-menu-item (click)="navigateFolder(breadcrumb.id)">
                    <mat-icon>folder</mat-icon>

                    {{ breadcrumb.name }}
                  </button>
                }
              </mat-menu>
            </ng-template>

            <ng-template #separator>
              <mat-icon
                class="align-middle mx-1 [--mat-icon-color:var(--color-gray-500)]"
                >chevron_right</mat-icon
              >
            </ng-template>
          </app-breadcrumbs>
          </div>
          <div class="flex gap-2">
            @if (!showPlaceholder()) {
              @if (selection.isEmpty()) {
                @if (!isSharedView()) {
                  <button *appHasPermission="'media:create'" mat-button [matMenuTriggerFor]="actionMenu">
                    Toevoegen

                    <mat-icon>add</mat-icon>
                  </button>
                }
              } @else if (!isSharedView() || canEditSelection()) {
                @if (selection.selected.length === 1) {
                  <button *appHasPermission="'media:create'" mat-icon-button class="inline-flex!" (click)="editMedia()">
                    <mat-icon matTooltip="Bewerken">edit</mat-icon>
                  </button>
                }
                @if (!isClientScope()) {
                  <button *appHasPermission="'media:share'" mat-icon-button class="inline-flex!" (click)="openMediaSettings()">
                    <mat-icon matTooltip="Instellingen">settings</mat-icon>
                  </button>
                }
                @if (!isSharedView() && !isSelectionShared() && canMoveFiles()) {
                  <button
                    mat-icon-button
                    class="inline-flex!"
                    matTooltip="Verplaatsen"
                    (click)="moveFiles(selection.selected)"
                  >
                    <mat-icon>drive_file_move</mat-icon>
                  </button>
                }
                <button
                  *appHasPermission="'media:delete'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Verwijderen"
                  (click)="deleteMedia()"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            }
          </div>
        </div>

        <div>
          <div
            class="grid grid-cols-[repeat(auto-fill,minmax(min(220px,100%),1fr))] gap-2"
          >
            @for (group of groups(); track $index) {
              <div
                class="flex items-center bg-gray-200 rounded-lg p-2 pl-4 select-none hover:bg-gray-300 transition-colors"
                (dblclick)="navigateFolder(group._id)"
              >
                <div class="flex flex-auto items-center overflow-hidden gap-2">
                  <mat-icon class="flex-none">{{ (isSharedView() || isFolderShared(group)) ? 'folder_shared' : 'folder' }}</mat-icon>

                  <div class="flex flex-col flex-auto pr-2 min-w-0">
                    <span class="font-medium text-sm truncate" [matTooltip]="group.label">{{ group.label }}</span>
                    @if (isSharedView() && !isOwnGroup(group) && group.unitLabel) {
                      <span class="text-xs text-gray-500 truncate">{{ group.unitLabel }}</span>
                    }
                  </div>
                </div>

                @if (!isSharedView() || isOwnGroup(group)) {
                  @if (canEditFolder() || canDeleteFolder()) {
                    <button
                      mat-icon-button
                      class="inline-flex! size-8! p-1!"
                      matTooltip="Meer"
                      [matMenuTriggerFor]="groupActionMenu"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }

                  <mat-menu #groupActionMenu="matMenu">
                    @if (canEditFolder()) {
                      <button mat-menu-item (click)="editFolderName(group)">
                        Naam wijzigen
                      </button>
                    }
                    @if (!isSharedView() && !isFolderShared(group)) {
                      @if (isPinned(group._id)) {
                        <button mat-menu-item (click)="togglePin(group._id)">Losmaken van snelle toegang</button>
                      }
                      @else {
                        <button mat-menu-item (click)="togglePin(group._id)">Vastmaken aan snelle toegang</button>
                      }
                    }
                    @if (!isClientScope()) {
                      <button *appHasPermission="'media:share'" mat-menu-item (click)="shareFolderMedia(group)">
                        {{ isFolderShared(group) ? 'Niet meer delen' : 'Delen' }}
                      </button>
                    }
                    @if (!isSharedView() && !isFolderShared(group) && canEditFolder()) {
                      <button mat-menu-item (click)="moveFolder(group)">Verplaatsen</button>
                    }
                    @if (canDeleteFolder()) {
                      <button mat-menu-item (click)="deleteFolder(group)">
                        Verwijderen
                      </button>
                    }
                  </mat-menu>
                }
              </div>
            }
          </div>
        </div>

        <div>
          @if (showPlaceholder()) {
            @if (isSharedView()) {
              <app-empty-state-placeholder
                icon="folder_shared"
                heading="Geen gedeelde media"
                message="Er is nog geen media gedeeld. Deel media via de instellingen van een media bestand."
              >
              </app-empty-state-placeholder>
            } @else {
              <app-empty-state-placeholder
                icon="subscriptions"
                heading="Je hebt nog geen media of folders"
                message="Begin met het toevoegen van media of het maken van folders om je bestanden te organiseren."
              >
                <div class="flex flex-wrap justify-center gap-2" ngProjectAs="button">
                  @if (canCreateFolder()) {
                    <button mat-flat-button (click)="addFolder()">
                      <mat-icon>create_new_folder</mat-icon>

                      Maak een nieuwe folder aan
                    </button>
                  }

                  <button *appHasPermission="'media:create'" mat-button (click)="handleUploadFile()">
                    <mat-icon>upload_file</mat-icon>

                    Upload bestanden
                  </button>

                  @if (isClientScope()) {
                    <button *appHasPermission="'media:create'" mat-button (click)="importFromLibrary()">
                      <mat-icon>library_add</mat-icon>

                      Importeren uit algemene media
                    </button>
                  }

                  <button *appHasPermission="'media:create'" mat-button (click)="importFromSystem()">
                    <mat-icon>category</mat-icon>

                    Importeren uit systeem
                  </button>
                </div>
              </app-empty-state-placeholder>
            }
          }
          <div class="grid grid-cols-(--columns) items-start gap-2">
            @for (media of dataSource(); track $index) {
              @if ($any(media).isOwn !== undefined) {
                <app-media-file-card
                  [data]="media"
                  [selectable]="$any(media).isOwn && canEditMedia()"
                  [selected]="selection.isSelected(media)"
                  (selectionChange)="handleSelectionChange($event, $index)"
                  [shareIndicator]="$any(media).isOwn ? 'own' : 'external'"
                  [ownerUnitLabel]="$any(media).ownerUnitLabel ?? ''"
                />
              } @else {
                <app-media-file-card
                  [data]="media"
                  [selectable]="canEditMedia()"
                  [selected]="selection.isSelected(media)"
                  (selectionChange)="handleSelectionChange($event, $index)"
                  [shareIndicator]="media.shareId ? 'own' : null"
                />
              }
            }
          </div>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<mat-menu #actionMenu="matMenu">
  @if (canCreateFolder()) {
    <button mat-menu-item (click)="addFolder()">
      <mat-icon>create_new_folder</mat-icon>
      Nieuwe folder
    </button>
  }
  <button mat-menu-item (click)="handleUploadFile()">
    <mat-icon>upload_file</mat-icon>
    Bestanden uploaden
  </button>
  @if (isClientScope()) {
    <button mat-menu-item (click)="importFromLibrary()">
      <mat-icon>library_add</mat-icon>
      Importeren uit algemene media
    </button>
  }
  <button mat-menu-item (click)="importFromSystem()">
    <mat-icon>category</mat-icon>
    Importeren uit systeem
  </button>
</mat-menu>
